"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CsmProvider = void 0;
const isomorphic_1 = require("../../isomorphic");
const utils_1 = require("../../utils");
class CsmProvider {
    emitUet(marker, scope) {
        var _a;
        if ((0, utils_1.isClientSide)()) {
            isomorphic_1.LOGGER.info(`Emitting uet metric for marker: ${marker}, scope: ${scope}`);
            (_a = window.uet) === null || _a === void 0 ? void 0 : _a.call(window, marker, scope);
        }
    }
    emitUex(marker, scope) {
        var _a;
        if ((0, utils_1.isClientSide)()) {
            isomorphic_1.LOGGER.info(`Emitting uex metric for marker: ${marker}, scope: ${scope}`);
            (_a = window.uex) === null || _a === void 0 ? void 0 : _a.call(window, marker, scope);
        }
    }
    emitUes(marker, scope, param) {
        var _a;
        if ((0, utils_1.isClientSide)()) {
            isomorphic_1.LOGGER.info(`Emitting ues metric for marker: ${marker}, scope: ${scope}, param: ${param && param.toString()}`);
            (_a = window.ues) === null || _a === void 0 ? void 0 : _a.call(window, marker, scope, param);
        }
    }
    emitTag(tag) {
        var _a, _b;
        if ((0, utils_1.isClientSide)()) {
            isomorphic_1.LOGGER.info(`Emitting tag: ${tag}`);
            (_b = (_a = window.ue) === null || _a === void 0 ? void 0 : _a.tag) === null || _b === void 0 ? void 0 : _b.call(_a, tag);
        }
    }
}
exports.CsmProvider = CsmProvider;
